
/* injects from baggage-loader */

'use strict';

export default class InvitationsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/invitations/invitations.controller.js